// Source: https://samanthaz.me/writing/finding-the-right-color-palettes-for-data-visualizations#our-palettes

export const TEAL_NAVY = {
  1: ['#5ebcd2'],
  2: ['#85cbcf', '#3984b6'],
  3: ['#85cbcf', '#3984b6', '#1d2e81'],
  4: ['#9ed5cd', '#44a7cb', '#2e62a1', '#192574'],
  5: ['#b7dfcb', '#5abad1', '#3984b6', '#264992', '#161f63'],
  6: ['#bee0cc', '#70c3d0', '#419dc5', '#316ba7', '#223b89', '#151e5e'],
  7: ['#c6e3cb', '#83cacf', '#47aed0', '#3984b6', '#2c5a9c', '#1e3082', '#141c59'],
  8: ['#cee6ca', '#91d0ce', '#56b9d2', '#3f97c2', '#3371aa', '#274b93', '#1b277c', '#131a55'],
  9: ['#d5e9ca', '#9ed5cd', '#69c0d1', '#44a7cb', '#3984b6', '#2e62a1', '#233f8c', '#192473', '#121850'],
  10: ['#dcecc9', '#aadacc', '#78c6d0', '#48b3d3', '#3e94c0', '#3474ac', '#2a5599', '#203686', '#18216b', '#11174b'],
  11: [
    '#dcecc9',
    '#afdccc',
    '#83cacf',
    '#56b9d2',
    '#43a1c7',
    '#3984b6',
    '#3067a5',
    '#274b93',
    '#1e3082',
    '#172068',
    '#11174b'
  ],
  12: [
    '#dcecc9',
    '#b3ddcc',
    '#8acdce',
    '#62bed2',
    '#46aace',
    '#3d91be',
    '#3577ae',
    '#2d5e9e',
    '#24448e',
    '#1c2b7f',
    '#162065',
    '#11174b'
  ]
}

export const AMBER_BROWN = {
  1: ['#f4b656'],
  2: ['#f8cd61', '#e97e3b'],
  3: ['#f8cd61', '#e97e3b', '#a34529'],
  4: ['#fbdb68', '#ef9c49', '#e45e2d', '#8b412b'],
  5: ['#fdea6f', '#f3b355', '#e97e3b', '#cf4f29', '#723c2c'],
  6: ['#fdeb73', '#f6c15b', '#ed9445', '#e66731', '#b84a29', '#6a3a2d'],
  7: ['#fdeb78', '#f8cb60', '#f0a44d', '#e97e3b', '#e3572a', '#a64629', '#63392d'],
  8: ['#fdec7c', '#f9d464', '#f2b154', '#ec8f43', '#e66c33', '#d35028', '#98432a', '#5b372e'],
  9: ['#fded82', '#fbdc68', '#f5bc59', '#ef9c49', '#e97e3b', '#e45e2d', '#c04b29', '#8a402b', '#54362f'],
  10: ['#fded86', '#fce36b', '#f7c65d', '#f1a84f', '#ec8c41', '#e76f34', '#e25328', '#b04829', '#7e3e2b', '#4c3430'],
  11: [
    '#fded86',
    '#fce66d',
    '#f8cb60',
    '#f2b154',
    '#ee9747',
    '#e97e3b',
    '#e5632f',
    '#d35028',
    '#a64629',
    '#793d2c',
    '#4c3430'
  ],
  12: [
    '#fded86',
    '#fde86e',
    '#f9d063',
    '#f5b857',
    '#f0a04b',
    '#eb8a40',
    '#e77235',
    '#e35b2c',
    '#c74e29',
    '#9d4429',
    '#753c2c',
    '#4c3430'
  ]
}

export const ROSE_VIOLET = {
  1: ['#e9668c'],
  2: ['#ee8695', '#a73b8f'],
  3: ['#ee8695', '#a73b8f', '#501b73'],
  4: ['#f19a9b', '#d54d88', '#7b2a95', '#461765'],
  5: ['#f4aea3', '#e8638b', '#a73b8f', '#61208d', '#3c1357'],
  6: ['#f6b5a4', '#eb7590', '#c8488a', '#872e93', '#581d7f', '#3a1353'],
  7: ['#f7bba6', '#ed8495', '#e05286', '#a73b8f', '#6f2597', '#511b75', '#37114e'],
  8: ['#f8c1a8', '#ef9198', '#e8608a', '#c0458a', '#8f3192', '#63218f', '#4b186c', '#33104a'],
  9: ['#f8c7aa', '#f19b9c', '#ea708e', '#d54d88', '#a73b8f', '#7a2995', '#5b1f84', '#451764', '#300f45'],
  10: ['#f9cdac', '#f2a49f', '#ec7c92', '#e65586', '#bc438b', '#933291', '#692398', '#551c7b', '#41155e', '#2d0f41'],
  11: [
    '#f9cdac',
    '#f3a8a1',
    '#ed8495',
    '#e8608a',
    '#cd4a89',
    '#a73b8f',
    '#822c94',
    '#63218f',
    '#511b75',
    '#3f145b',
    '#2d0f41'
  ],
  12: [
    '#f9cdac',
    '#f3aca2',
    '#ee8b97',
    '#e96a8d',
    '#db5087',
    '#b8428c',
    '#973490',
    '#742796',
    '#5e1f88',
    '#4d1a70',
    '#3d1459',
    '#2d0f41'
  ]
}
